var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.variants.length)?_c('ImageCheckboxGroup',_vm._b({attrs:{"label":_vm.label,"avatar-props":{
    size: 24,
    fillColor: 'transparent',
  },"name":"platforms"},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}},'ImageCheckboxGroup',{ variants: _vm.variants },false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }